import {
  RECHARGE_VALUES_FETCH,
  RECHARGE_VALUES_ADD,
  RESET_RECHARGE_VALUES,
} from "../constants/actionTypes";

const doFetchRechargeValues = (disableLoading = false) => ({
  type: RECHARGE_VALUES_FETCH,
  payload: { disableLoading },
});

const doSaveRechargeValues = rechargeValues => ({
  type: RECHARGE_VALUES_ADD,
  payload: rechargeValues,
});

const doResetRechargeValues = () => ({
  type: RESET_RECHARGE_VALUES,
});

export { doSaveRechargeValues, doFetchRechargeValues, doResetRechargeValues };
